import React from 'react';
import { pdf, DocumentProps } from '@react-pdf/renderer';
import { HistoricalReport } from './HistoricalReport';
import { HistoricalReportData } from './types';
import { saveBlob } from '../saveBlob';

export const generateHistoricalPDF = async (
  data: HistoricalReportData,
  filename: string
): Promise<void> => {
  const element = React.createElement(
    HistoricalReport,
    { data }
  ) as React.ReactElement<DocumentProps>;
  const blob = await pdf(element).toBlob();
  await saveBlob(blob, filename);
};
